import DonationContainer from "../components/donationContainer";

function Donations() {
  return (
    <>
      <DonationContainer />
    </>
  );
}

export default Donations;
